import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../../mock'
import axios from 'axios.js'


const getAllStreetUser = async ()=>{
    const response = await axios.get(buildApiUrl('reference/getAllStreet/'));

    const {error, errorInfo, result, message, data } = response.data;
    const AllStreetUser = data;

    // console.log('Сервер вернул данные по отметкам - ',response.data);


    return AllStreetUser;
};


const setActiveStreet = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setStreetActive/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllStreetUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Street  - ',response);


    return AllStreetUser;
};



const setDeletedStreet = async (id,val)=>{
    const response = await axios.post(buildApiUrl('reference/setStreetDeleted/'),{
        id,
        val
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllStreetUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Street  - ',response);


    return AllStreetUser;
};




const setUpdateStreet = async (dataStreetUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setStreetUpdate/'),{
        dataStreetUpdate
    });

    const {error, errorInfo, result, message, data } = response.data;
    const AllStreetUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Street  - ',dataStreetUpdate,response);


    return AllStreetUser;
};


const setSaveNewStreet = async (dataStreetUpdate)=>{
    const response = await axios.post(buildApiUrl('reference/setSaveNewStreet/'),{
        dataStreetUpdate
    });
    const {error, errorInfo, result, message, data } = response.data;
    const AllStreetUser = data;

    // console.log('Сервер вернул данные по обновлению статуса Street  - ',response, dataStreetUpdate);


    return AllStreetUser;
};

Mock.onGet('/api/reference/getAllStreet').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllStreetUser = await getAllStreetUser();
    // console.log('С сервера пришло - ', AllStreetUser);

    // if (!AllStreetUser) {
    //     return [400, { message: 'Список цветов отсутствует!' }]
    // }


    if (!AllStreetUser) {
        return [200, [] ]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllStreetUser,
    ]


})


Mock.onPost('/api/reference/setActiveStreet').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllStreetUser = await setActiveStreet(id,val);

    // if (!AllStreetUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllStreetUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllStreetUser,
    ]


})

Mock.onPost('/api/reference/setDeletedStreet').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { id } = JSON.parse(config.data);
    let { val } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ',id, val, config.data);

    const AllStreetUser = await setDeletedStreet(id,val);

    // if (!AllStreetUser) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }


    if (!AllStreetUser) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllStreetUser,
    ]


})


Mock.onPost('/api/reference/setUpdateStreet').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataStreetUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Street = await setUpdateStreet(dataStreetUpdate);

    // console.log('Серовер вернул данные ',AllStreetUser);

    // if (!Street) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Street) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Street,
    ]


})


Mock.onPost('/api/reference/setSaveNewStreet').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    let { dataStreetUpdate } = JSON.parse(config.data);
    // console.log('Данные для отправки на сервер ', config.data);

    const Street = await setSaveNewStreet(dataStreetUpdate);

    // console.log('Серовер вернул данные ',AllStreetUser);

    // if (!Street) {
    //     return [400, { message: 'Список пометок отсутствует!' }]
    // }

    if (!Street) {
        return [200, []]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        Street,
    ]
})